<template>
  <div>
    <van-sticky>

      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">课程列表</div>
      </nav-bar>

      <van-tabs v-model="activeWeek" @click="weeksOnChange">
        <van-tab title="周一" name="周一"></van-tab>
        <van-tab title="周二" name="周二"></van-tab>
        <van-tab title="周三" name="周三"></van-tab>
        <van-tab title="周四" name="周四"></van-tab>
        <van-tab title="周五" name="周五"></van-tab>
      </van-tabs>

      <van-tabs v-model="activeTimes" @click="timesOnChange">
        <van-tab title="一二节" name="12节"></van-tab>
        <van-tab title="三四节" name="34节"></van-tab>
        <van-tab title="五六节" name="56节"></van-tab>
        <van-tab title="七八节" name="78节"></van-tab>
      </van-tabs>

    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in courses" :key="item.id">
          <van-cell :border="false" :label="'最大人数:'+item.maxp"
                    :title="item.cname+' 教师:'+item.tName" value="<--">
            <van-button square type="warning" @click="selectCourse(item.id,item.cname)" text="选课"/>
            <van-button square type="primary" @click="lookCourse(item.id)" text="详情"/>
          </van-cell>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>

    <van-action-sheet v-model="descriptionShow" :title="this.cname+' 课程介绍'+'当前人数:'+this.countp">
      <van-notice-bar
        left-icon="volume-o"
        :text=" '选课开始时间' + new Date(parseInt(this.startTime)).toLocaleString()"
      />
      <div style="  padding: 16px 16px 70px;font-size: 18px;font-family: 楷体;">{{ this.description }}</div>

    </van-action-sheet>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar";
import {getCourseList, getCourseById} from "../../../network/course";
import {SelectCourse} from "../../../network/selectCourse";
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Field,
  Popup,
  Picker,
  Cell,
  Button,
  PullRefresh,
  List,
  SwipeCell,
  Toast, Dialog,
  ActionSheet,
  NoticeBar,
  Sticky
} from 'vant';


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Cell);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Sticky);

export default {
  name: "SelectList",
  components: {
    NavBar
  },
  data() {
    return {
      courses: [],

      //tab
      activeWeek: "周一",
      activeTimes: "12节",

      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //ActionSheet
      descriptionShow: false,
      startTime: "",
      cname: "",
      description: "",
      countp: 0,
    };
  },
  activated() {
    this.getCourseLists();
  },
  // created() {
  //   this.getCourseList();
  // },
  computed: {
    getCourses() {
      let a = this.courses.filter(item => {
        // return item.week == this.activeWeek && item.times == this.activeTimes && item.countp < item.maxp;
        return item.week == this.activeWeek && item.times == this.activeTimes;
      });
      return a;
    },
  },
  methods: {
    weeksOnChange() {
      this.getCourseLists();
    },
    timesOnChange() {
      this.getCourseLists();
    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.courses = [];
      // 重新加载数据
      this.getCourseLists();
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      // setTimeout(() => {
      //
      //   this.isLoading = false;
      // }, 1000);
    },
    getCourseLists() {
      getCourseList(this.$cookies.get("info").gId, this.activeWeek, this.activeTimes).then(res => {
        this.courses = [];
        this.courses.push(...res);
      });
    },
    selectCourse(id, cname) {
      let ts = this.courses.filter(item => item.id === id)[0];
      // if (ts.countp >= ts.maxp) {
      //   Toast.fail('人数已满');
      //   return;
      // }
      if (parseInt(ts.starttime) > new Date().getTime()) {
        Toast.fail('未到选课时间');
        return;
      }
      Dialog.confirm({
        title: '提示',
        message: this.activeWeek + ' ' + this.activeTimes + ' ' + cname + '确定要选择吗'
      }).then(() => {
        SelectCourse(id).then(res => {
            if (res.selected) {
              // Toast.success('选课成功');
              Dialog({message: '选课成功，课程二维码点击 “我的->当前课程”即可查看'});
            } else {
              Toast.fail(res.message);
            }
          }
        ).catch(res => {
          Toast.fail("选课失败");
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    lookCourse(id) {
      let course = this.courses.filter(item => item.id === id)[0];
      getCourseById(course.id).then(res => {
        this.description = res.course.des;
        this.countp = res.countp;
      });
      this.startTime = course.starttime;
      this.cname = course.cname;
      this.descriptionShow = true;
    },
    onClickLeft() {
      this.$router.replace("/home");
    }
  }
}
</script>

<style scoped>
.home-nav {
  background-color: var(--color-tint);
  color: #fff;
}

.test {
  width: 70%;
  display: flex;

  position: fixed;

  right: 0;

}
</style>
